import React from "react";

/**
 * Founding seat chip — the COMPACT density of the founding identity (the plate is the full lockup,
 * the feed-card text is the favicon). Reads "FOUNDING #<n>": the WORD plus the numeral, GOLD, in a
 * thin gold hairline box. Same vocabulary as the plate ("FOUNDING MEMBER #<n>") and the feed text
 * ("· FOUNDING #<n>") — one identity at three sizes.
 *
 * GOLD on EVERY account type. Founding is a single, globally-unique seat sequence (exactly one #7
 * across the platform; backend/founding.py unique index `seat_number_uniq`), so the number never
 * needs a per-type color. Account type is carried by the Dealer Verified chip / role, never here.
 *
 * NO STAR (removed 2026-06 to match the plate + feed text, which never had one). The star used to be
 * SPEC 1's non-color signal for grayscale/colorblind readers; the literal word "FOUNDING" + the
 * numeral are themselves non-color signals present on every surface, so it is no longer needed.
 *
 * Renders nothing unless there is a confirmed (paid) seat number; a pending seat renders no placeholder.
 * `dense` = the solid-background variant; use ONLY in rows under 40px tall. Outline is the default.
 */
export function FoundingSeatChip({ seat, accountType, dense = false, testid }) {
  const n = Number(seat);
  if (!Number.isInteger(n) || n < 1) return null;

  const isBusiness = String(accountType || "").toLowerCase() === "business";
  const skin = {
    text: "#E8C46A",
    border: dense ? "#6B551C" : "#E8C46A",
    bg: dense ? "#3A2F10" : "transparent",
  };

  return (
    <span
      data-testid={testid || `founding-seat-chip-${n}`}
      title={`Founding member #${n}${isBusiness ? " · business" : ""}`}
      className="inline-flex items-center align-middle whitespace-nowrap"
      style={{
        color: skin.text,
        backgroundColor: skin.bg,
        border: `1px solid ${skin.border}`,
        borderRadius: 0,
        padding: "3px 8px",
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontSize: "10px",
        letterSpacing: "0.06em",
        lineHeight: 1,
      }}
    >
      FOUNDING #{n}
    </span>
  );
}

export default FoundingSeatChip;
